import Vue from 'vue'
import http from '../utils/http';

export default {
    state: {
        teams: [],
        team: null,
        teamMessage: '',
    },
    mutations: {
        loadTeams(state, payload) {
			state.teams = payload
		},
        setTeam(state, payload) {
			state.team = payload
		},
        addTeam(state, payload) {
            const index = state.teams.length
            Vue.set(state.teams, index, payload)   
        },
        deleteTeam(state, payload) {
            console.log(payload)
            state.team = null;
            /* state.games = state.games?.filter(s => s.id !== payload); */  
        },
        teamMessage(state, payload) {
            state.teamMessage = payload;
        }
    },
    actions: {
        async fetchTeams({ commit, getters }, payload) {
            commit('clearError')
            commit('setLoading', true)

            let limit = payload.limit ? payload.limit : getters.num_teams;
            let gameId = payload.gameId ? payload.gameId : payload;
            
            try {
                const result = await http.get(`/teams/game/${ gameId }?limit=${limit}`);
                if (result) {
                    commit('loadTeams', result.data)             
                    commit('setLoading', false) 
                }
            }catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
            }    
        },
        async fetchTeam({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.get(`/teams/${ payload }`);
                if (result) {
                    commit('setTeam', result.data) 
                }
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false) 
            }
                           
            commit('setLoading', false)
        },
        //admin
        async addTeam({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                const result = await http.post(`/teams`, payload);
                //console.log(result)
                if (result) {
                   const team = await result.data 
                   commit('addTeam', team)
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async editTeam({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.put(`/team/${payload.id}`, payload);
                commit('setTeam', payload);              
                commit('setLoading', false);
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteTeam({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/team/${payload}`);
                commit('deleteTeam', payload);              
                commit('setLoading', false);
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },

        //professor (rewrite team, products, channels, spots && resources)
        async createTeam({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            const teamDto = {
                gameId: payload.gameId,
                name: payload.name
            }

            try {
                const result = await http.post(`/teams`, teamDto);
                //console.log(result)
                if (result) {
                    // products
                    payload.products.forEach(async(prod) => {
                        const prodDto = { ...prod, teamId: result.data.id }
                        await http.post('/product', prodDto)
                   })
                    // channels
                    payload.channels.forEach(async(chan) => {
                        const channel = await http.get(`/channel/${chan.id}`)

                        if (channel) {
                            delete chan.id
                            let trademarks = [];
                            
                            if (channel.data.trademarks) {
                              trademarks  = channel.data.trademarks.map(item => item.name)
                            }
                             
                            const chanDto = { ...chan, teamId: result.data.id, trademarks: trademarks }
                            await http.post('/channel', chanDto);
                        }   
                   })

                    // spots
                    payload.spots.forEach(async(spot) => {
                        const spotDto = { ...spot, teamId: result.data.id }
                        await http.post('/spot', spotDto)
                   })

                    // resources
                    payload.resources.forEach(async(resource) => {
                        const resourceDto = { ...resource, teamId: result.data.id }
                        await http.post('/resource', resourceDto)
                   })
                   
                    const team = await result.data 
                    commit('teamMessage', `team ${team.name} created successfull`)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        }
    },
    getters: {
        teams(state) {
            return state.teams;
        },
        teamMessage(state) {
            return state.teamMessage;
        },
        team(state) {
            return state.team;
        }
    }
}